import React from 'react';
import { Link as ReactLink } from 'react-router-dom';

export default function Button({
  children,
  to = null,
  action = null,
  icon = null,
  isIconLeft = false,
  isExpanded = true,
}) {
  return (
    <div
      data-component-name='Button'
      className={`flex items-center justify-center text-lg rounded-lg ${
        isExpanded === true ? 'w-full' : 'max-w-max'
      } text-white-400 bg-button-gradient`}
    >
      {to !== null && (
        <ReactLink
          to={to}
          className={`flex items-center gap-2.5 whitespace-nowrap h-11 px-4 `}
        >
          {icon !== null && isIconLeft === true && <div className='-ml-0.5'>{icon}</div>}
          {children}
          {icon !== null && isIconLeft === false && <div className='-mr-0.5'>{icon}</div>}
        </ReactLink>
      )}
      {action !== null && (
        <button
          type='button'
          onClick={() => action()}
          className={`flex items-center gap-2.5 whitespace-nowrap h-11 px-4`}
        >
          {icon !== null && isIconLeft === true && <div className='-ml-0.5'>{icon}</div>}
          {children}
          {icon !== null && isIconLeft === false && <div className='-mr-0.5'>{icon}</div>}
        </button>
      )}
    </div>
  );
}
